import { pageSeo } from "@/data/pageSeo";

export interface PageSeo {
  title: string;
  description: string;
  canonical: string;
  noindex?: boolean;
}

export function seoHead(page: PageSeo) {
  const url = new URL(page.canonical, "https://pneu360.ch").href;
  const image = "https://pneu360.ch/og-image.jpg";
  return {
    meta: [
      { title: page.title },
      { name: "description", content: page.description },
      // Environment-wide exclusions are enforced by the server's
      // X-Robots-Tag header; page-specific exclusions live here.
      { name: "robots", content: page.noindex ? "noindex, nofollow" : "index, follow" },
      { property: "og:title", content: page.title },
      { property: "og:description", content: page.description },
      { property: "og:url", content: url },
      { property: "og:type", content: "website" },
      { property: "og:image", content: image },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { property: "og:locale", content: "de_CH" },
      { property: "og:site_name", content: "Pneu 360" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: page.title },
      { name: "twitter:description", content: page.description },
      { name: "twitter:image", content: image },
    ],
    links: [{ rel: "canonical", href: url }],
  };
}

export function pageHead(path: keyof typeof pageSeo) {
  return seoHead(pageSeo[path]);
}

export function notFoundHead() {
  return {
    meta: [
      { title: "Seite nicht gefunden | Pneu 360" },
      { name: "description", content: "Die angeforderte Seite wurde nicht gefunden." },
      { name: "robots", content: "noindex, nofollow" },
    ],
    links: [],
  };
}
